/* eslint-disable no-nested-ternary */
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import { getTimezoneInGMT, IsTablet } from 'Utils/UtilityFunctions';
import {
  greyColor,
  maxMobile,
  maxTablet, maxWidth, midMobile, primaryColor, primaryFont, primaryHeadingColor,
  retina, secondaryFont, wLight, wMBold,
  wMedium,
} from 'Utils/utilsStyle';
import { Modal } from 'antd';
import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import MoveFolderDocumentTable from 'Pages/document/MoveFolderDocumentTable';
import { useDispatch, useSelector } from 'react-redux';
import { selectDrawerOpen, selectFoldersPopupData, selectUploadDocuments } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import EmptyStateDocumentHub from 'Components/document/EmptyStateDocumentHub';
import AddPlusIcon from '../assets/svgIcons/AddPlusIcon';
import GlobalButton from '../components/GlobalButton';
import { selectShowUploadDocument } from 'Selector/GlobalSearchContentSelector';

const StyledModal = styled(Modal)`
&.ant-modal {
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 504px !important;
  }
  .ant-modal-content {
    .ant-modal-close {
      display: none;
    }
    .ant-modal-body {
      padding: 32px 0px 0px;
    .header-popup-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;
      .header-title {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 26px;
        font-weight: ${wMBold};
        line-height: 28px;
        letter-spacing: -1px;
        margin-bottom: 0px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 24px;
        }
      }
      .right-side-header {
        display: flex;
        align-items: center;
      .search-div {
          position: relative;
          .search-wrapper{
            .ant-input-affix-wrapper {
              padding: 6.5px 10px 6.5px 17px;
              height: 30px;
              @media all and (max-width: ${maxWidth}), ${retina}{
                height: 30px;
              }
              .ant-input-prefix {
                display: none;
              }
              .ant-input  {
                font-size: 14px;
                font-weight: ${wLight};
                @media all and (max-width: ${maxWidth}), ${retina}{
                  font-size: 14px;
                  line-height: 16px;
                }
              }
              .ant-input::placeholder {
                font-weight: ${wLight} !important;
              }
            }
            .cross-icon {
              cursor: pointer;
              top: 7px;
              right: 10px;
              @media all and (max-width: ${maxWidth}), ${retina}{
                top: 8px;
              }
            }
            &.iconModeSearch {
              width: 30px;
              .ant-input-affix-wrapper { 
                padding: 0px;
                .ant-input-prefix {
                  display: flex;
                  svg {
                    @media all and (max-width: ${maxTablet}) {
                      margin-left: 0px;
                    }
                  }
                }
              }
            }
            &.expandModeSearch {
              width: 288px;
              margin: 0px 0px 0px 0px;
              @media all and (max-width: ${maxWidth}), ${retina}{
                width: 288px;
              }
              @media all and (max-width: ${maxMobile}) {
                width: 240px;
              }
              @media all and (max-width: ${midMobile}) {
                width: 290px;
              }
            }
            width: 288px;
            margin: 0px 12px 0px 0px;
            @media all and (max-width: ${maxWidth}), ${retina}{
              width: 288px;
            }
          }
        }
        .create-folder-btn {
          font-family: ${primaryFont};
          font-size: 12px;
          font-weight: ${wMedium};
          line-height: 14px;
          .add-plus-icon {
            margin-right: 8px;
            width: 10px;
            height: 10px;
          }
        }
      }
    }
    }
    .ant-modal-footer {
      height: 87px;
      padding: 28px 32px 28px !important;
      border-radius: 0px 0px 16px 16px;
      border: 1px solid #E7E7E7;
      background: #FFF;
    }
  }  
}
`;
const Footer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
.selected-text {
  color: ${greyColor};
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 18px;
  margin-right: 8px;
  letter-spacing: -0.633px;
  max-width: calc(100% - 110px);
  @media all and (max-width: ${maxMobile}) {
    font-size: 14px;
  }
}
.footer-btns-div {
  display: flex;
  align-items: center;
  .cancel-button {
    &.move {
      border: 1px solid ${primaryColor};
      color: #fff;
      background-color: ${primaryColor};
      margin-left: 8px;
    }
    display: inline-flex;
    align-items: center;
    border-radius: 23px;
    border: 1px solid ${greyColor};
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMBold};
    padding: 8px 16px 9px 12px;
    cursor: pointer;
    height: 31px;
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      padding: 7px 12px;
    }
  }
}
`;

type Props = {
  selectedDocuments: string
  unSelectedDocuments: string
  selectedDocumentsCount: number
  isSelectAll: boolean
  searchTerm: string
  selectedFolders: string
  unSelectedFolders: string
  uploadedByMe: boolean
  currentFolderId: number
};

const AddItemToFolderModal = function AddItemToFolderModal(props: Props) {
  const isTab = IsTablet();
  const dispatch = useDispatch();
  const [query, setQuery] = useState<string>('');
  const foldersPopup = useSelector(selectFoldersPopupData);
  const {
    visible, foldersCount, type, selectedFolder, searchTerm: popupSearchTerm, loaded, loading, selectedDocumentIds,
    moveCopyLoading,
  } = foldersPopup;
  const showUploadDocument = useSelector(selectShowUploadDocument);
  const drawerOpen = useSelector(selectDrawerOpen);
  const uploadDocuments = useSelector(selectUploadDocuments);
  const fileDialogOpenedRef = useRef<boolean>(false);
  const windowFocusTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const filesBeforeDialogRef = useRef<number>(0);

  const {
    uploadedByMe, selectedDocuments,
    unSelectedDocuments, selectedFolders, unSelectedFolders, isSelectAll,
    selectedDocumentsCount, currentFolderId,
  } = props;

  const togglePopup = () => {
    dispatch(actions.toggleFoldersPopup(!visible));
    setQuery('');
    // Reset file dialog tracking when popup closes
    fileDialogOpenedRef.current = false;
    if (windowFocusTimeoutRef.current) {
      clearTimeout(windowFocusTimeoutRef.current);
      windowFocusTimeoutRef.current = null;
    }
  };

  // Detect file dialog cancellation when opened from submit button
  useEffect(() => {
    if (type === 'upload' && fileDialogOpenedRef.current && drawerOpen && selectedFolder?.id) {
      const handleWindowFocus = () => {
        // When window regains focus after file dialog
        if (windowFocusTimeoutRef.current) {
          clearTimeout(windowFocusTimeoutRef.current);
        }

        // Check if files were actually selected
        windowFocusTimeoutRef.current = setTimeout(() => {
          const currentFileCount = uploadDocuments.length;
          // If no new files were added, dialog was cancelled
          if (currentFileCount === filesBeforeDialogRef.current) {
            // Reset selected folder and close drawer/popup when file selection is cancelled
            dispatch(actions.setFoldersPopupSelectedFolder(null));
            dispatch(actions.toggleFoldersPopup(false));
            dispatch(actions.setDrawerOpen(false));
            fileDialogOpenedRef.current = false;
          } else {
            // Files were selected, reset tracking
            fileDialogOpenedRef.current = false;
          }
          windowFocusTimeoutRef.current = null;
        }, 100);
      };

      const handleWindowBlur = () => {
        // Window loses focus when file dialog opens
        filesBeforeDialogRef.current = uploadDocuments.length;
      };

      window.addEventListener('focus', handleWindowFocus);
      window.addEventListener('blur', handleWindowBlur);

      return () => {
        window.removeEventListener('focus', handleWindowFocus);
        window.removeEventListener('blur', handleWindowBlur);
        if (windowFocusTimeoutRef.current) {
          clearTimeout(windowFocusTimeoutRef.current);
        }
      };
    }
  }, [type, drawerOpen, selectedFolder?.id, uploadDocuments.length, dispatch]);

  const handleSubmit = () => {
    if (type === 'upload') {
      // Only proceed if a folder has been selected
      if (!selectedFolder?.id) {
        return;
      }
      togglePopup();
      // Track that we're opening file dialog
      fileDialogOpenedRef.current = true;
      filesBeforeDialogRef.current = uploadDocuments.length;
      const element = document.getElementsByClassName('ant-upload-btn')[0];
      setTimeout(() => {
        (element as HTMLElement)?.click();
      }, 500);
    }
    if (type === 'copy' || type === 'move') {
      if (selectedDocumentIds.length) {
        dispatch(actions.moveCopyDocuments({
          selectedDocuments: selectedDocumentIds[0].toString(),
          unSelectedDocuments: '',
          action: type,
          moveFolderId: selectedFolder?.id || 0,
          timezone: getTimezoneInGMT(),
          isSelectAll: false,
          ...(currentFolderId > 0 && { folderId: currentFolderId }),
        }));
      } else {
        dispatch(actions.moveCopyDocuments({
          selectedDocuments,
          unSelectedDocuments,
          action: type,
          moveFolderId: selectedFolder?.id || 0,
          timezone: getTimezoneInGMT(),
          isSelectAll,
          selectedFolders,
          unSelectedFolders,
          uploadedByMe,
          ...(currentFolderId > 0 && { folderId: currentFolderId }),
        }));
      }
    }
  };

  const onSearching = (value: string) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length && popupSearchTerm !== trimmedValue) {
      dispatch(actions.setFoldersPopupSearchText(trimmedValue));
      setQuery(trimmedValue);
      dispatch(actions.setFoldersPopupSelectedFolder(null));
    } else if (popupSearchTerm.length && !trimmedValue.length) {
      dispatch(actions.setFoldersPopupSearchText(''));
      setQuery('');
      dispatch(actions.setFoldersPopupSelectedFolder(null));
    }
  };

  const handleCancel = () => {
    dispatch(actions.setFoldersPopupSelectedFolder(null));
    // Reset file dialog tracking
    fileDialogOpenedRef.current = false;
    if (windowFocusTimeoutRef.current) {
      clearTimeout(windowFocusTimeoutRef.current);
      windowFocusTimeoutRef.current = null;
    }
    togglePopup();
  };

  return (
    <StyledModal
      open={visible}
      centered
      width={1169}
      height={717}
      getContainer=""
      wrapClassName="add-item-to-folder-popups"
      onCancel={handleCancel}
      maskClosable={false}
      footer={(
        <Footer>
          <span className="selected-text">
            {type !== 'upload' ? (
              `${type === 'move' ? 'Move' : 'Copy'}
               ${selectedDocumentIds.length === 1 || selectedDocumentsCount === 1 ? '1 item' : `${selectedDocumentsCount} items`}`
            ) : null}
          </span>
          <div className="footer-btns-div">
            <span
              role="button"
              tabIndex={0}
              className={classNames('cancel-button')}
              onKeyPress={handleCancel}
              onClick={handleCancel}
            >
              Cancel
            </span>
            <span
              role="button"
              tabIndex={0}
              className={classNames('cancel-button move', { disabled: (type === 'upload' && !selectedFolder?.id) || !selectedFolder?.id || moveCopyLoading })}
              onKeyPress={handleSubmit}
              onClick={handleSubmit}
            >
              {
                type === 'copy' ? 'Copy' : type === 'move' ? 'Move' : 'Submit'
              }
            </span>
          </div>
        </Footer>
      )}
    >
      <div className="header-popup-div">
        <h3 className="header-title">{type === 'upload' ? 'Select a folder to upload your file' : `All Folders (${foldersCount})`}</h3>
        <div className="right-side-header">
          <div className="search-div">
            <AlertsSearch
              placeholderText="Search a file or document"
              onSearching={onSearching}
              iconMode={isTab}
              query={query}
              loading={loading && !loaded}
            />
          </div>
          {showUploadDocument ?
            <GlobalButton
              title="Create Folder"
              IconLeft={<AddPlusIcon color="#fff" />}
              LeftSpace="12px"
              PaddingSm="5px 10px"
              innerSpace="5.5px 14px"
              heightSm="30px"
              height="30px"
              bgColor={primaryColor}
              textColor="#fff"
              onButtonClick={() => { dispatch(actions.setCreateFolderPopupVisible(true)); }}
              buttonClassName={classNames('create-folder-btn')}
            /> : null
          }

        </div>
      </div>
      {loaded && !loading && !foldersCount ? <EmptyStateDocumentHub isSearch emptyDocHub={false} modelFlag /> : (
        <div className="table-div">
          <MoveFolderDocumentTable />
        </div>
      )}

    </StyledModal>
  );
};

export default AddItemToFolderModal;
